module.exports = __webpack_public_path__ + "img/qihui_home_image_jointqrcode@2x.e1c23037.png";